import React, { forwardRef } from 'react';
import { Checkbox as MuiCheckbox, FormControlLabel } from '@material-ui/core';
import { useDsTokens } from '../theme/useDsTokens';
import { cn } from '../utils/cn';
import { DsCommonProps, DsValidationProps } from './types';

export interface CheckboxProps extends DsCommonProps, DsValidationProps {
  checked?: boolean;
  defaultChecked?: boolean;
  indeterminate?: boolean;
  name?: string;
  value?: string;
  label?: React.ReactNode;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(function Checkbox(
  {
    id,
    className,
    disabled,
    error,
    required,
    checked,
    defaultChecked,
    indeterminate,
    name,
    value,
    label,
    inputProps,
    onChange,
    'data-testid': testId,
  },
  ref
) {
  const tokens = useDsTokens();

  const control = (
    <MuiCheckbox
      id={id}
      ref={ref}
      className={cn(className)}
      data-testid={testId}
      color="primary"
      checked={checked}
      defaultChecked={defaultChecked}
      indeterminate={indeterminate}
      disabled={disabled}
      required={required}
      name={name}
      value={value}
      inputProps={{
        ...inputProps,
        'aria-invalid': error ? true : undefined,
      }}
      onChange={onChange}
      style={{
        color: error ? tokens.statusError : tokens.brandPrimary,
        opacity: disabled ? tokens.opacityDisabled : 1,
      }}
    />
  );

  if (label) {
    return (
      <FormControlLabel
        control={control}
        label={label}
        disabled={disabled}
        style={{
          color: disabled ? tokens.textDisabled : tokens.textPrimary,
          fontSize: tokens.fontSizeBody,
        }}
      />
    );
  }

  return control;
});

Checkbox.displayName = 'Checkbox';
